module.exports = __webpack_public_path__ + "static/media/MX.56d013ff.svg";